import ProductGallery from "../../components/ProductGallery/ProductGallery";

const Products: React.FC = () => {
  return (
    <div
      className="
        relative
        w-full
        overflow-hidden
        flex
      "
      style={{
        height: "calc(100vh - 64px)", // ONLY header height
      }}
    >
      <ProductGallery />
    </div>
  );
};

export default Products;

